export default __webpack_public_path__ + "static/media/sumukh.d62e299d.jpg";